"use client";

import { Check } from "@phosphor-icons/react";
import { useTranslations } from "next-intl";

interface IndustryApplicationsProps {
	namespace: string;
	items: readonly string[];
	brandColor?: string;
}

export default function IndustryApplications({
	namespace,
	items,
	brandColor = "#64a525",
}: IndustryApplicationsProps) {
	const t = useTranslations(namespace);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12">
					<div className="lg:w-[36%]">
						<h2 className="mb-3 text-2xl font-bold leading-[1.3] text-black sm:mb-4 sm:text-[30px] sm:leading-[1.28] md:text-4xl md:leading-[1.25]">
							{t("applicationsTitle")}
						</h2>
						<p className="text-sm leading-relaxed text-black md:text-base">{t("applicationsDesc")}</p>
					</div>

					<div className="lg:flex-1">
						<div className="rounded-sm bg-[#ebf5ea] px-6 py-7 sm:px-8 sm:py-8">
							<div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
								{items.map((key) => (
									<div key={key} className="flex items-center gap-2.5">
										<Check size={20} weight="bold" className="shrink-0" style={{ color: brandColor }} />
										<span className="text-sm leading-snug text-black md:text-base">{t(key)}</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
